import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {i18n} from './plugins/i18n'
import VueGoogleCharts from 'vue-google-charts'
Vue.use(VueGoogleCharts)

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)

import VueRadioToggleButtons from 'vue-radio-toggle-buttons';
import 'vue-radio-toggle-buttons/dist/vue-radio-toggle-buttons.css';

Vue.use(VueRadioToggleButtons)

import '../public/style.css'

import firebase from 'firebase'
import './components/firebaseInit'

import axios from 'axios'
import vueAxios from 'vue-axios'

Vue.use(vueAxios, axios)


import VueFriendlyIframe from 'vue-friendly-iframe';

Vue.use(VueFriendlyIframe);

import Sticky from 'vue-sticky-directive'
Vue.use(Sticky)

import store from './store'
import IdleVue from 'idle-vue'

const eventsHub = new Vue();

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 600000, // 10 minutes = 600000 ms
  startAtIdle: false
});

//

// import VeeValidate from "vee-validate";
// import ru from "vee-validate/dist/locale/ru";
// import en from "vee-validate/dist/locale/en";


// Vue.use(VeeValidate, {
  
//   dictionary: {
//     ru: {
//       messages: ru.messages,
//       attributes: { mail: "Эл.почта" }
//     },
//     en: {
//       messages: en.messages,
//       attributes: { mail: "mail test" }
//     }
//   }
// });

//

Vue.config.productionTip = false

let app
firebase.auth().onAuthStateChanged( () => {
  if (!app){
    app = new Vue({
      i18n,
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})